import styled, { css } from 'styled-components';
import Row from '~/grid/Row';
import Col from '~/grid/Col';
import ContactInfoBlock from './partials/ContactInfoBlock';
import { ContainerLargeType } from '../ContainerLarge/ContainerLarge.helpers';
import { mq } from '~/styles/grid';

const PictureCol = styled(Col)`
  display: flex;
  justify-content: ${(props) =>
    props.width === 4 ? 'flex-end' : 'flex-start'};

  @media (${mq.mdDown}) {
    justify-content: flex-start;
  }
`;

const TextCol = styled(Col)`
  ${(props) =>
    !props.hasPhoto &&
    css`
      @media (${mq.mdUp}) {
        margin: 12.5px;
      }
    `}
`;

const StyledImg = styled.img`
  max-width: 240px;
  max-height: 240px;
  width: 100%;
  height: auto;
  object-fit: contain;
  object-position: 0 0;
`;

/**
 * @param {TeaserContactProps} props
 * @returns {React.ReactElement} The rendered component
 */
const TeaserContact = ({
  photo,
  isBrand,
  formattedName,
  title,
  organization,
  streetAddress,
  extendedAddress,
  locality,
  region,
  postalCode,
  countryName,
  countryCode,
  email,
  telephoneNumber,
  mobileNumber,
  websiteUrl,
  socialProfileLinkedIn,
  socialProfileXing,
  whatsAppNumber,
  containerType,
  elmIndex,
}) => {
  const isContainerTooSmall =
    containerType === ContainerLargeType.C ||
    (containerType === ContainerLargeType.B1 && elmIndex === 0) ||
    (containerType === ContainerLargeType.B2 && elmIndex === 1);
  const containerExceptionWidth = isContainerTooSmall ? 12 : 7;
  const containerExceptionOffset = isContainerTooSmall ? 0 : 1;
  const desktopWidth = photo ? containerExceptionWidth : 12;
  const photoWidth = isContainerTooSmall ? 12 : 4;

  return (
    <Row>
      {photo && (
        <PictureCol
          width={photoWidth}
          colAmount={{
            xl: photoWidth,
            lg: photoWidth,
            md: photoWidth,
            sm: 12,
            xs: 12,
          }}
        >
          <StyledImg src={photo} alt={formattedName} />
        </PictureCol>
      )}
      <TextCol
        hasPhoto={(photo && true) || false}
        colAmount={{
          xl: desktopWidth,
          lg: desktopWidth,
          md: desktopWidth,
          sm: 12,
          xs: 12,
        }}
        offset={{
          xl: containerExceptionOffset,
          lg: containerExceptionOffset,
          md: containerExceptionOffset,
          sm: 0,
          xs: 0,
        }}
      >
        <ContactInfoBlock
          formattedName={formattedName}
          title={title}
          organization={organization}
          streetAddress={streetAddress}
          extendedAddress={extendedAddress}
          postalCode={postalCode}
          locality={locality}
          region={region}
          countryName={countryName}
          countryCode={countryCode}
          email={email}
          telephoneNumber={telephoneNumber}
          mobileNumber={mobileNumber}
          websiteUrl={websiteUrl}
          socialProfileLinkedIn={socialProfileLinkedIn}
          socialProfileXing={socialProfileXing}
          whatsAppNumber={whatsAppNumber}
          isBrand={isBrand}
        />
      </TextCol>
    </Row>
  );
};

export default TeaserContact;
